// extracted by mini-css-extract-plugin
module.exports = {"container":"AddUser_container__fBiFH","plus":"AddUser_plus__2YDgn","addUser":"AddUser_addUser__3gEAC"};